export const PRIVATE_AREA_IDS_FORM_FIELD_NAME = "_areaIds";
